import { 
    IDI_INSPECTION_DASHBOARD_START_LOADING, 
    IDI_INSPECTION_DASHBOARD_END_LOADING,
    SET_IDI_INSPECTION_DASHBOARD_FILTER_SEARCH,
    IDI_INSPECTION_DASHBOARD_DRAFT_LOADED, 
    IDI_INSPECTION_DASHBOARD_PENDING_FOR_INSPECTION_LOADED,
    IDI_INSPECTION_DASHBOARD_INSPECTION_IN_PROCESS_LOADED,
    IDI_INSPECTION_DASHBOARD_READY_FOR_REVIEW_LOADED,
    IDI_INSPECTION_DASHBOARD_UPLOAD_TO_TAWUNIYA_LOADED,
    IDI_INSPECTION_DASHBOARD_COMPLETED_LOADED,
    IDI_INSPECTION_DASHBOARD_CLOSED_LOADED,
    IDI_INSPECTION_DASHBOARD_ABORTED_LOADED,
    IDI_INSPECTION_DASHBOARD_USER_SEARCH_LOADED
} from "../constants/IdiInspectionDashboardConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIdiInspectionDashboard(status, search) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTION_DASHBOARD_START_LOADING });

        try {

            var data = await getApiData("IdiInspection/GetIdiInspectionGroupFBO", { status, search }, null);
            
            if(data.success) {
                if(status === null || status === "" || status === "Draft") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_DRAFT_LOADED,
                        payload: data.responseEntities[0].draftList
                    });
                }

                if(status === null || status === "" || status === "Pending for Inspection") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_PENDING_FOR_INSPECTION_LOADED,
                        payload: data.responseEntities[0].pendingForInspectionList
                    });
                }

                if(status === null || status === "" || status === "Inspection In Process") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_INSPECTION_IN_PROCESS_LOADED,
                        payload: data.responseEntities[0].inspectionInProcessList
                    });
                }

                if(status === null || status === "" || status === "Ready for Review") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_READY_FOR_REVIEW_LOADED,
                        payload: data.responseEntities[0].readyForReviewList
                    });
                }

                if(status === null || status === "" || status === "Upload To Tawuniya") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_UPLOAD_TO_TAWUNIYA_LOADED,
                        payload: data.responseEntities[0].uploadToTawuniyaList
                    });
                }

                if(status === null || status === "" || status === "Completed") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_COMPLETED_LOADED,
                        payload: data.responseEntities[0].completedList
                    });
                }

                if(status === null || status === "" || status === "Closed") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_CLOSED_LOADED,
                        payload: data.responseEntities[0].closedList
                    });
                }

                if(status === null || status === "" || status === "Aborted") {
                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_ABORTED_LOADED,
                        payload: data.responseEntities[0].abortedList
                    });
                }

                await dispatch({
                    type: IDI_INSPECTION_DASHBOARD_USER_SEARCH_LOADED,
                    payload: data.responseEntities[0].userSearches
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_INSPECTION_DASHBOARD_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTION_DASHBOARD_END_LOADING });
        }
    };
}

export function setIdiInspectionDashboardFilterSearch(search) {
    return async (dispatch) => {
        await dispatch({
            type: SET_IDI_INSPECTION_DASHBOARD_FILTER_SEARCH,
            payload: search
        });
    };
}

export function assignIdiInspection(idiInspectionId, userId, assignMe, items, index) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTION_DASHBOARD_START_LOADING });

        try {

            var data = await postApiJsonData("IdiInspection/AssignIdiInspection", { idiInspectionId, userId, assignMe }, null);
            
            if(data.success) {
                if(data.responseEntities[0].status === "Ready for Review") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: IDI_INSPECTION_DASHBOARD_READY_FOR_REVIEW_LOADED,
                        payload: items
                    });
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: IDI_INSPECTION_DASHBOARD_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTION_DASHBOARD_END_LOADING });
        }
    };
}